var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hospital-db-layout"},[_c('layout-header'),_c('div',{staticClass:"hospital-db-layout-content"},[_c('router-view'),_c('layout-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }